/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./EventTarget',
	'jquery',
	'../../../util/KeyCodes'
], function(
	EventTarget,
	$,
	KeyCodes
) {

	class NonVIPREventTarget extends EventTarget {
		constructor (...args) {
			super(...args);
		}

		getTargetsByCords() {
			return [];
		}

		decorateTarget () {
			//IndentedList and Table support decorate by default
			return true;
		}

		getDecoration() {
		}

		getValuesAtPoint(/*event , offset*/) {
		}

		completeDecorations () {
		}

		applyCustomDataSelection () {
		}

		getCustomDataSelections () {
			return [];
		}

		canZoom () {
			return false;
		}

		zoom () {
		}

		zoomStart () {
		}

		zoomEnd () {
		}

		pan () {
		}

		panStart () {
		}

		panEnd () {
		}

		_getKeyDownEventCoordinates (event){
			event.clientX = $(event.target).offset().left + event.target.offsetWidth / 2;
			event.clientY = $(event.target).offset().top + event.target.offsetHeight / 2;
			return event;
		}

		_getTargetNode (event = {}) {
			return event.gesture ? event.gesture.target : event.target;
		}

		_canProcessKeyDown (event) {
			return event.type === 'keydown' && event.keyCode === KeyCodes.KEY_ENTER;
		}

		processKeyDown (event) {
			const result = this._canProcessKeyDown(event);
			if (result) {
				this._getKeyDownEventCoordinates(event);
			}
			return result;
		}

		mouseWithinBoundCheck (event){
			if (this.getTargetElement()){
				let boundingRect = this.getTargetElement().get(0).getBoundingClientRect();
				return event.pageX > boundingRect.left &&
				event.pageX < boundingRect.right &&
				event.pageY > boundingRect.top &&
				event.pageY < boundingRect.bottom;
			}
			return false;
		}
	}

	return NonVIPREventTarget;
});
